import './SpaceBetweenColumnLayout.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps extends PropsWithChildren {
  className?: string;
}

export const SpaceBetweenColumnLayout = ({ children, className }: IProps): ReactElement => (
  <div className={classNames('space-between-column-layout', className)}>{children}</div>
);
